import React, { FC } from "react";

export const RightAngleIcon: FC = () => {
    return (
        <svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 14L12 7.5L5 1" stroke="currentColor" fill="none" strokeLinecap="square" />
        </svg>
    );
}